import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Podcastlisting(porps) {

    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how
                            technology played a crucial role in transforming their businesses and how it helps them
                            scale up with sustainability.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>The story of Guardian Angel – A lesson in saving lives using a mobile app for entrepreneurs</h4>
                            <div className="podcast_txt">
                                <p>In Episode #03 our host was Mr. JR Ridge, actor, producer, and the entrepreneur who founded Guardian Angel discusses the hardship of starting a business from scratch with no investment...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-ep3"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>How Businesses Are Using Technology To Evolve During Covid-19 and The Role of Tech In The Future of Entrepreneurship</h4>
                            <div className="podcast_txt">
                                <p>In Episode #02, Mr. Gene Deems, the eGov and services manager from the department of natural resources joined us who discusses the evolution of technology...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-ep2"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>How Steve Built A Successful Business While Saving Lives Through The Veteran App</h4>
                            <div className="podcast_txt">
                                <p>In episode #01, we sat with the founder of “The Veteran App” to discuss the role of technology in saving lives and creating positive impact in the world...</p>
                            </div>
                            <Link to="/podcast/technology-for-change-ep1"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>

                </Row>
            </Container>
        </div>
    );

}


export default Podcastlisting;